import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Backdrop, Grow, Modal } from '@material-ui/core';

const SolicitudDetalleModal = ({ solicitud, onClose }) => {
	if (!solicitud) return null;

	return (
		<Modal open={!!solicitud} onClose={onClose} closeAfterTransition BackdropComponent={Backdrop} BackdropProps={{ timeout: 300 }}>
			<Grow in={!!solicitud}>
				<div tabIndex="-1" role="dialog">
					<div className="modal-lg modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header bg-fleet">
								<h4 className="modal-title text-white mb-0">
									<i className="la la-comment align-middle icon-modal-title"></i>{' '}
									<FormattedMessage id="solicitudDetalleModal.titulo" defaultMessage="Detalle de la solicitud {numero}" values={{ numero: solicitud.numero }} />
								</h4>
								<button type="button" className="close" aria-label="Close" onClick={onClose}>
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
							<div className="modal-body modal-grey modal-mh ovf-x-hidden">
								<div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{solicitud.detalle}</div>
							</div>
							<div className="modal-footer modal-grey">
								<button type="button" className="btn btn-default btn-fleet" onClick={onClose}>
									<FormattedMessage id="solicitudDetalleModal.ok" defaultMessage="Ok" />
								</button>
							</div>
						</div>
					</div>
				</div>
			</Grow>
		</Modal>
	);
};

export default SolicitudDetalleModal;
